import DELIVERY from 'content/fragments/delivery';

/** Copy aligned with getsquarefare.com/this-weeks-menu */
export const MENU_PAGE_COPY = {
  title: "This week's menu",
  deliveryOffice:
    'Office deliveries: contact Claire to discuss: claire@getsquarefare.com.',
  serviceArea: 'Currently serving NYC and some parts of NJ, Westchester, CT and Long Island',
  selectionLead: "We're excited to cook for you! Please make your selection below by:",
  orderDeadlines: DELIVERY.cutoffs,
  contactDifferentTime: 'Looking for a different delivery time or location?',
};

// Lunch and Dinner are shown as ONE section for à la carte ordering — the same
// dishes were listed twice, which confused customers (Claire, Jul 2026). Each
// card carries a portion dropdown that sets the meal type and price.
export const MENU_SECTIONS = [
  { id: 'breakfast', label: 'Breakfast', mealTypes: ['Breakfast'] },
  { id: 'lunch', label: 'Lunch', mealTypes: ['Lunch'], priceNote: '(from $19.99)' },
  { id: 'dinner', label: 'Dinner', mealTypes: ['Dinner'], priceNote: '(from $23.99)' },
  { id: 'family-platter', label: 'Family Platter', mealTypes: ['Family Platter'], priceNote: '(4 portions, from $79.96)' },
  { id: 'snacks', label: 'Snacks', mealTypes: ['Snack'] },
  { id: 'addons', label: 'Add-ons & Gift Cards', mealTypes: ['Add On'] },
];

export const ADDON_UNCATEGORIZED_LABEL = 'More add-ons';

// The portions a dish can be ordered as, in the order they're offered. Add On and
// Packaging are deliberately absent — they're not portions of a meal.
export const MEAL_TYPE_ORDER = ['Breakfast', 'Lunch', 'Dinner', 'Family Platter', 'Snack'];

// A Family Platter is N lunch servings of one dish, priced at N x the Lunch price;
// checkout writes it as N Lunch rows in Open Orders.
export const FAMILY_PLATTER = 'Family Platter';
export const FAMILY_PLATTER_SERVINGS = 4;
